import { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { dictionary } from "../../../utils/dictionary";
import { MessageCircle } from "lucide-react";
import CustomerConversationList from "./CustomerConversationList";
import UnifiedChatDetail from "./UnifiedChatDetail";
import ContactDetailPanel from "./ContactDetailPanel";
import { useCustomerChatStore } from "../../../store/customerChatStore";
import { decodeTokenService } from "../../../services/decodeTokenService";

const ChatInbox = () => {
  const { language } = useAuth();
  const {
    selectedPhone,
    customers,
    customerConversation: conv,
    fetchCustomers,
    selectCustomer,
  } = useCustomerChatStore();
  const [showContactPanel, setShowContactPanel] = useState(false);

  // When the user switches to a contact-less view (no selected phone),
  // collapse the panel so the empty state can take the full width.
  useEffect(() => {
    if (!selectedPhone) setShowContactPanel(false);
  }, [selectedPhone]);

  const customerFromList = customers.find((c) => c.customer_phone === selectedPhone);
  const displayName =
    customerFromList?.display_name ||
    customerFromList?.customer_name ||
    conv?.customer_name ||
    selectedPhone ||
    null;

  return (
    <div className="flex h-full bg-[#F0F2F5] overflow-hidden">
      {/* Left panel - Customer list (grouped by phone) */}
      <div className="w-[320px] bg-white border-r border-gray-200 flex flex-col flex-shrink-0">
        <CustomerConversationList />
      </div>

      {/* Center panel - Unified chat detail */}
      <div className="flex-1 flex flex-col min-w-0">
        {selectedPhone ? (
          <UnifiedChatDetail
            onOpenContactPanel={() => setShowContactPanel(true)}
          />
        ) : (
          <div className="flex-1 flex items-center justify-center bg-[#F0F2F5]">
            <div className="text-center">
              <div className="w-14 h-14 bg-[#00A884]/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <MessageCircle className="w-6 h-6 text-[#00A884]" />
              </div>
              <p className="text-[#667781] text-sm font-medium mb-1">
                {dictionary["chat-select-conversation"][language]}
              </p>
              <p className="text-[#667781] text-xs">
                {dictionary["chat-select-conversation"][language]}
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Right panel - Contact detail (inline, keeps chat interactive) */}
      {showContactPanel && selectedPhone && (
        <div className="w-[380px] border-l border-gray-200 flex-shrink-0">
          <ContactDetailPanel
            phone={selectedPhone}
            displayName={displayName}
            onClose={() => setShowContactPanel(false)}
            onContactChanged={() => {
              const ownerId = decodeTokenService.getUserIdFromToken();
              if (ownerId) fetchCustomers(ownerId);
            }}
            onContactDeleted={() => {
              const ownerId = decodeTokenService.getUserIdFromToken();
              if (ownerId) selectCustomer("", ownerId);
              setShowContactPanel(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ChatInbox;
